module.exports = __webpack_public_path__ + "tables/media/fontawesome-webfont.fee66e71.woff";